<template>
  <div class="sns-post-item-header-parts">
    <img class="sns-post-item-header-parts__thumbnail" :src="snsPost.thumbnail" alt="" />

    <p class="sns-post-item-header-parts__user-name" v-text="snsPost.username" />

    <i class="sns-post-item-header-parts__sns-icon">
      <img
        v-if="snsPost.linkType === 'instagram'"
        :src="require('@/assets/img/icon/icon_instagram.svg')"
        alt=""
      />
      <img
        v-else-if="snsPost.linkType === 'twitter'"
        :src="require('@/assets/img/icon/icon_x.svg')"
        alt=""
      />
      <img
        v-else-if="snsPost.linkType === 'highlights'"
        :src="require('@/assets/img/icon/icon_highlights.svg')"
        alt=""
      />
    </i>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/composition-api'
import { SnsPostData } from '@/store/stores/pageStore/HomePage/HomePageStore'

/**
 * HOME SNSコンテンツ 投稿アイテム ヘッダーパーツ
 */
export default defineComponent({
  name: 'SnsPostItemHeaderParts',
  props: {
    snsPost: {
      type: Object as PropType<SnsPostData>,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.sns-post-item-header-parts {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  padding-bottom: min(#{convertPXtoVW(9), 9px});
  margin-bottom: min(#{convertPXtoVW(8), 8px});
  border-bottom: 1px solid $black05;

  &__thumbnail {
    width: min(#{convertPXtoVW(24), 24px});
    height: min(#{convertPXtoVW(24), 24px});
    border-radius: 50%;
    object-fit: cover;
  }

  &__user-name {
    display: block;
    width: calc(100% - min(#{convertPXtoVW(58), 58px}));
    margin: 0 min(#{convertPXtoVW(8), 8px});
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    font-family: $fontSignup;
    font-weight: 700;
    font-size: 13px;
    line-height: 1.54;
    letter-spacing: 0.04em;
    color: $black20;
  }

  &__sns-icon {
    width: min(#{convertPXtoVW(18), 18px});
  }
}
</style>
